import { render } from "./DialogassociaRappCliente.vue?vue&type=template&id=7e478719&scoped=true"
import script from "./DialogassociaRappCliente.vue?vue&type=script&lang=js"
export * from "./DialogassociaRappCliente.vue?vue&type=script&lang=js"

import "./DialogassociaRappCliente.vue?vue&type=style&index=0&id=7e478719&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e478719"]])

export default __exports__